import { faChevronDown, faChevronUp, faHeart, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

import { GroupEntity } from "@/mk2/apps/blogs/schemas";
import { UserConfigurationEntity } from "@/mk2/apps/strollers/schemas";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { Img } from "@/mk2/components/Img";
import useEventCallback from "@/mk2/hooks/useEventCallback";
import {
    CLOSE_WINDOW,
    TERM_GROUP_GUIDE_ANSWER,
    TERM_GROUP_GUIDE_CONNECT,
    TERM_GROUP_GUIDE_CONNECT_ONE,
    TERM_GROUP_GUIDE_CONNECT_TWO,
    TERM_GROUP_GUIDE_DONE,
    TERM_GROUP_GUIDE_SAY_HELLO,
} from "@/mk/autogenerated/translation";
import assetUrl from "@/mk/common/assetUrl";

import styles from "./ConnectToGroup.mscss";

interface OwnProps {
    isComment: boolean;
    isPost: boolean;
    group: GroupEntity;
    isClosed: boolean;
    onGuideComplete(groupId: number, isClosedByUser: boolean);
}

interface State {
    client: boolean;
    userConfiguration: UserConfigurationEntity;
}

const handleOnGuideComplete = (groupId, isClosedByUser, onGuideComplete) => {
    onGuideComplete(groupId, isClosedByUser);
};

export class ConnectToGroup extends React.Component<OwnProps, State> {
    public render() {
        const { isComment, isPost, isClosed, onGuideComplete, group } = this.props;
        const showConnect = () => {
            if (!isComment || !isPost) {
                return <ConnectToGroupValues isComment={isComment} isPost={isPost} />;
            }
            if (isPost && isComment) {
                return (
                    <Done
                        groupId={group.id}
                        isClosed={isClosed}
                        onGuideComplete={onGuideComplete}
                    />
                );
            }
        };
        return <div className={styles.ConnectToGroup}>{showConnect()}</div>;
    }
}

interface DoneOwnProps {
    groupId: number;
    isClosed: boolean;
    onGuideComplete(groupId: number, isClosedByUser?: boolean);
}

const Done: React.FunctionComponent<DoneOwnProps> = ({ groupId, onGuideComplete, isClosed }) => {
    const [showDone, setShowOptions] = useState<boolean>(isClosed);
    const onXClick = useEventCallback(() => {
        setShowOptions(!showDone);
        handleOnGuideComplete(groupId, true, onGuideComplete);
    }, [setShowOptions]);

    const closeButton = () => {
        return (
            <div className={styles.ConnectToGroup__close}>
                <span>{CLOSE_WINDOW}</span>
                <FontAwesomeIcon className={styles.ConnectToGroup__xIcon} icon={faTimes} />
            </div>
        );
    };

    return (
        <>
            {!showDone && (
                <div className={styles.ConnectToGroup__header}>
                    <Img
                        className={styles.ConnectToGroup__img}
                        height={22}
                        width={22}
                        src={assetUrl + "img/forum/smile-done.svg"}
                    />
                    <span className={styles.ConnectToGroup__header__textBlock}>
                        <span className={styles.ConnectToGroup__header__text}>
                            {TERM_GROUP_GUIDE_DONE}
                        </span>
                    </span>
                    <div className={styles.ConnectToGroup__header__close}>
                        <Btn type={BtnType.GreyText} label={closeButton()} onClick={onXClick} />
                    </div>
                </div>
            )}
            {showDone && <></>}
        </>
    );
};

Done.displayName = "Done";

interface ConnectToGroupValuesOwnProps {
    isComment: boolean;
    isPost: boolean;
}

const ConnectToGroupValues: React.FunctionComponent<ConnectToGroupValuesOwnProps> = ({
    isPost,
    isComment,
}) => {
    const [showOptions, setShowOptions] = useState<boolean>(1 >= 2);
    const onToggleShowOptions = useEventCallback(() => {
        setShowOptions(!showOptions);
    }, [setShowOptions]);

    const guideCount = () => {
        if ((!isComment && isPost) || (isComment && !isPost)) {
            return 1;
        } else return 2;
    };

    return (
        <div className={styles.ConnectToGroup__block} onClick={onToggleShowOptions}>
            <div className={styles.ConnectToGroup__header}>
                <Img
                    className={styles.ConnectToGroup__img}
                    height={22}
                    width={22}
                    src={assetUrl + "img/forum/smile-red.svg"}
                />
                <span className={styles.ConnectToGroup__header__textBlock}>
                    <span className={styles.ConnectToGroup__header__text}>
                        {TERM_GROUP_GUIDE_CONNECT}
                    </span>
                    {guideCount() === 1 && (
                        <span className={styles.ConnectToGroup__header__textCondition}>
                            {TERM_GROUP_GUIDE_CONNECT_ONE}
                        </span>
                    )}
                    {guideCount() === 2 && (
                        <span className={styles.ConnectToGroup__header__textCondition}>
                            {TERM_GROUP_GUIDE_CONNECT_TWO}
                        </span>
                    )}
                </span>
                <Btn
                    icon={showOptions ? faChevronUp : faChevronDown}
                    type={BtnType.Link}
                    onClick={onToggleShowOptions}
                    className={styles.ConnectToGroup__button}
                />
            </div>
            {showOptions && (
                <div>
                    <div className={styles.ConnectToGroup__value}>
                        {isPost === true && (
                            <Img
                                className={styles.ConnectToGroup__valueimg}
                                height={22}
                                width={22}
                                src={assetUrl + "img/forum/done.svg"}
                            />
                        )}
                        {isPost === false && (
                            <Img
                                className={styles.ConnectToGroup__valueimg}
                                height={22}
                                width={22}
                                src={assetUrl + "img/forum/num-1.svg"}
                            />
                        )}
                        {TERM_GROUP_GUIDE_SAY_HELLO}
                    </div>
                    <div className={styles.ConnectToGroup__value}>
                        {isComment === true && (
                            <Img
                                className={styles.ConnectToGroup__valueimg}
                                height={22}
                                width={22}
                                src={assetUrl + "img/forum/done.svg"}
                            />
                        )}
                        {isComment === false && (
                            <Img
                                className={styles.ConnectToGroup__valueimg}
                                height={22}
                                width={22}
                                src={assetUrl + "img/forum/num-2.svg"}
                            />
                        )}
                        {TERM_GROUP_GUIDE_ANSWER}
                    </div>
                </div>
            )}
        </div>
    );
};

ConnectToGroupValues.displayName = "ConnectToGroupValues";
